import React from 'react';

import { useParams } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';
import { type SupportedChain } from '@pkg/types';

import config from '@app/config';
import { useIsWishlistOwner } from '@app/pages/Wishlist/hooks/useIsWishlistOwner';
import { PathParams } from '@app/routes/types';
import { useWishlistMetadataStore } from '@app/store/zustand';

import { ShareButton } from './ShareButton';
import { WishlistButton } from './WishlistButton';
import { WishlistManageButton } from './WishlistManageButton';

import { ButtonGroup, Wrapper } from './styles';

interface CardBottomProps {
    contract?: string | null;
    token_id?: string | null;
    collection_slug?: string | null;
    isCollectionTile?: boolean;
    chain?: SupportedChain;
}

export const CardBottom = ({ chain, contract, token_id, collection_slug, isCollectionTile }: CardBottomProps) => {
    const isRegisteredUser = useAppSelector((state) => state.user.isRegisteredUser);

    const { wishlistMetadata } = useWishlistMetadataStore();
    const isWishlistOwner = useIsWishlistOwner({ ownerId: wishlistMetadata?.user_id });
    const { [PathParams.WishlistSlug]: wishlistSlug } = useParams();

    return (
        <Wrapper>
            <ButtonGroup></ButtonGroup>
            <ButtonGroup>
                {isRegisteredUser && (
                    <>
                        {!isCollectionTile && chain && (
                            <WishlistButton
                                chain={chain}
                                contract={contract || undefined}
                                token_id={token_id || undefined}
                            />
                        )}

                        {isCollectionTile && chain && (
                            <WishlistButton chain={chain} collection_slug={collection_slug || undefined} />
                        )}
                    </>
                )}
                {!isCollectionTile && contract && chain && token_id ? (
                    <ShareButton shareUrl={`https://${config.publicUrl}/${chain}/${contract}/${token_id}`} />
                ) : null}
                {isCollectionTile && collection_slug && chain ? (
                    <ShareButton shareUrl={`https://${config.publicUrl}/collection/${chain}/${collection_slug}`} />
                ) : null}

                {isWishlistOwner && Boolean(wishlistSlug) && (
                    <WishlistManageButton
                        wishListModalData={{
                            name: undefined,
                            image: undefined,
                            contract_address: contract || undefined,
                            token_id: token_id || undefined,
                            slug: collection_slug || undefined,
                        }}
                    />
                )}
            </ButtonGroup>
        </Wrapper>
    );
};
